import { useEffect, useState } from "react";
import { useTenders } from "../../../tools/api";
import { complexDigitToman, convertToJalaliWithTime, formatTime } from "../../../tools/tools";
import styles from "./landingDetails.module.scss";
import { Table } from "antd";
const TenderBidders = ({ tenderid = 0 }) => {
  const { queryTenderBidders } = useTenders();

  //loading....
  const [isLoadingList, setIsLoadingList] = useState(false);

  const [bTable, setBTable] = useState([]);
  //state current page show Records
  const [currentPage, setCurrentPage] = useState(0);
  // state totalRecord
  const [totalRecord, setTotalRecord] = useState(0);

  useEffect(() => {
    const initialData = async () => {
      try {
        const payloadBidders = {
          searchconfigmodel: {
            sort: "",
            filter: "",
            entriesperpage: 10,
            page: currentPage === 0 ? 0 : currentPage - 1,
            totalrowcount: 0,
          },
          auctionproductid: tenderid,
        };
        const response = await queryTenderBidders(payloadBidders);
        if (response) {
          setIsLoadingList(true);
          response.Result = response.Result.sort((a, b) => (a.operationDate < b.operationDate ? 1 : -1));
          let listTemp = response.Result.map((item, key) => ({
            key: key,
            // no: key + 1,
            recommender: <>{item?.firstName}</>,
            datetime: (
              <span dir="ltr">
                {convertToJalaliWithTime(item?.operationDate)} - {formatTime(new Date(item?.operationDate))}
              </span>
            ),
            proposed: (
              <>
                <span>{complexDigitToman(item?.auctionOfferPrice)} </span>تومان
              </>
            ),
          }));
          setBTable(listTemp);
          setTotalRecord(response?.searchconfigmodel?.totalrowcount);
          setIsLoadingList(false);
        }
      } catch (error) {
        console.error(error);
        setIsLoadingList(false);
      }
    };
    if (tenderid != 0) {
      initialData();
    }
  }, [currentPage, tenderid]);

  return (
    <>
      <div className="holder_table">
        <Table
          columns={[
            // {
            //   title: "ردیف",
            //   dataIndex: "no",
            //   key: "no",
            // },
            {
              title: "پیشنهاد دهنده",
              dataIndex: "recommender",
              key: "recommender",
            },
            {
              title: "تاریخ",
              dataIndex: "datetime",
              key: "datetime",
            },
            {
              title: "قیمت پیشنهادی",
              dataIndex: "proposed",
              key: "proposed",
            },
          ]}
          pagination={{
            onChange: (page) => {
              setCurrentPage(page);
            },
            hideOnSinglePage: true,
            pageSize: 10,
            align: "start",
            current: currentPage === 0 ? 1 : currentPage,
            total: totalRecord,
            showSizeChanger: false,
          }}
          dataSource={bTable}
        />
      </div>
    </>
  );
};

export default TenderBidders;
